import { useEffect, useState } from 'react'
import Profile from './Profile'

const Team = () => {
    const [team, setTeam] = useState([])
    useEffect(() => {
        fetch('./about.json')
            .then(res => res.json())
            .then(data => setTeam(data))
    }, [])

    return (
        <>
        <h1 className="text-indigo-700 text-3xl text-center py-6 font_poppins font-semibold">Meet with our Team</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {
                team.map((item) => (
                    <Profile key={Math.random()} {...item} />
                ))
            }
        </div>
        </>
    )
}

export default Team
